import { html, LitElement } from 'lit-element';
import { PieMathRenderer } from '../classroom-tool-extensions/common/PieMathRenderer.js';
import { defaultCellFontSize, responseStyles } from '../cssUtils.js';
import {
  defineElement,
  importMathRendering,
} from '../classroom-tool-extensions/classifier/utils.js';

/**
 * @element math-inline-response
 * @prop {Object} model - The model for the pie
 * @prop {Object} session - The response session
 * @cssprop --pie-live-session-background-color - change the background color
 * @cssprop --pie-live-session-font-size-small - change the font size
 * @cssprop --pie-live-session-text-color - change the text color
 * @cssprop --pie-live-session-response-height - change the height (must be valid, eg: 100px, 10em )
 * @cssprop --pie-live-session-response-width - change the width (must be valid, eg: 100px, 10em )
 */
export class MathInlineResponse extends LitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      session: { type: Array, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    defineElement('math-rendering-element', PieMathRenderer);

    if (!this.mathRenderingModuleUrlImported) {
      importMathRendering();

      this.mathRenderingModuleUrlImported = true;
    }
  }

  render() {
    const { completeAnswer, response } = this.session || {};

    // for Advanced Multi type, we get `completeAnswer`, for Simple type, we get `response`
    const responseValue = completeAnswer || response;
    const completeAnswerHTML = `<div><span data-latex="" data-raw="${responseValue}">${responseValue}</span></div>`;

    if (!responseValue) return html`<div class="response"></div>`;

    return html` <style>
        ${responseStyles} .math-inline.response {
          font-size: var(
            --pie-live-session-font-size-small,
            ${defaultCellFontSize}px
          );
        }
      </style>
      <div class="response math-inline">
        <math-rendering-element
          .label="${completeAnswerHTML}"
        ></math-rendering-element>
      </div>`;
  }
}

export default MathInlineResponse;
